import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { CarTableDataService } from './car-table-data.service';
import { MatTableDataSource } from '@angular/material/table';
import { ModuleName } from '../Enum/common.enum';
import { Router } from '@angular/router';
import { LoaderService } from '../../shared/loader/loader.service';
import { StatusConstant } from '../status/status-constant';
import { DatePipe } from '@angular/common';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { EncryptionService } from '../../encryption/encryption.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';

export class Group {
  level = 0;
  parent: Group;
  expanded = true;
  totalCounts = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}
@Component({
  selector: 'app-group-listing-table',
  templateUrl: './group-listing-table.component.html',
  styleUrls: ['./group-listing-table.component.scss'],
  providers: [DatePipe],
})
export class GroupListingTableComponent implements OnInit {

  isAnyRecordAvailable: boolean = false;
  coreList:any=[]=[];
  currentUser: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  folderID:number=0;
  OfficeIDList: any = [];
  myOfficeID: any;
  ToogleColumnFields:any=[]=[];
  coreFieldColumnToogle:any=[]=[];
  coreUserListReceived = false;
  coreListReceived = false;
  coreFieldList:any=[]=[];
  coreFieldListNew:any=[]=[];
  _returnList: any[] = [];
  diplayList: any[] = [];
  coreListNew: any[] = []; 
  _returnColumns: any[] = [];
  mainModuleName:string="";
  orgModuleName:string="";
 
  dataSource = new MatTableDataSource<any | Group>([]);
  _alldata: any[];
  columns: any[];
  groupByColumns: string[] = [];
  displayedColumns: string[];  
  targetList: any = [];  
  dataSources1: any = [];  
  showView = new EventEmitter();  
  modulename: string;
  CCCList: any=[]=[];
  FieldColumnToogle: any=[]=[];
  value :string="";
  filterText:string="";
  totalCount:number=0;
  clickEventsubscriptions: Subscription;
  
  constructor(private router: Router,private loaderService: LoaderService,
    private statusConst: StatusConstant,public datepipe: DatePipe,
    private settingsService: SettingService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private dialog: MatDialog,private _dataSharingService: DataSharingService) {   
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId')?? '';
       this.organizationId = sessionStorage.getItem('organizationID')?? '';
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
  }
  
  //  ngOnChanges(changes: SimpleChanges) {
  //   var name = sessionStorage.getItem('gridViewModuleName');
  //   var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  //   this.CCCList = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core || x.mainModuleName == ModuleName.Contact || x.mainModuleName == ModuleName.Company);
    
  //  var GetFolderId = [];
  //  GetFolderId = this.CCCList.filter((x:any) => x.mainModuleName == name);
  //  if (GetFolderId.length > 0) {
  //     this.folderID = GetFolderId[0].folderID;
  //    if (GetFolderId[0].mainModuleName == ModuleName.Core) {        
  //      this.mainModuleName =GetFolderId[0].mainModuleName;
  //      this.orgModuleName =GetFolderId[0].orgModuleName;
  //    }
  //    if (GetFolderId[0].mainModuleName == ModuleName.Contact) {        
  //      this.mainModuleName =GetFolderId[0].mainModuleName;
  //      this.orgModuleName =GetFolderId[0].orgModuleName;
  //    }
  //    if (GetFolderId[0].mainModuleName == ModuleName.Company) {       
  //      this.mainModuleName =GetFolderId[0].mainModuleName;
  //      this.orgModuleName =GetFolderId[0].orgModuleName;
  //    }
  //  }

  //  if(name==ModuleName.Core){
  //    this.getCoreList("");
  //  }
  //  if(name==ModuleName.Contact){
  //    this.getContactList("");
  //  }
  //  if(name==ModuleName.Company){
  //    this.getCompanyList("");
  //  }
  // //   var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  // //   this.CCCList = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core || x.mainModuleName == ModuleName.Contact || x.mainModuleName == ModuleName.Company);
    
  // //   this.columns =  this.displayedColumns;
  // //   this.displayedColumns;
  // //   this.groupByColumns = ['Name'];

    
  // //   this._alldata = this.dataSources1;//data.data;
  // //   this.dataSource.data = this.addGroups(
  // //     this._alldata,
  // //     this.groupByColumns
  // //   );
  // //   this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
  // //   this.dataSource.filter = performance.now().toString();
  //  }

  ngOnDestroy() {
    this.clickEventsubscriptions.unsubscribe();
  }

  ngOnInit() {
    this.clickEventsubscriptions = this._dataSharingService.GetGroupingList3C().subscribe(() => {
      var name = sessionStorage.getItem('gridViewModuleName');
     var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
     this.CCCList = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core || x.mainModuleName == ModuleName.Contact || x.mainModuleName == ModuleName.Company);
     
    var GetFolderId = [];
    GetFolderId = this.CCCList.filter((x:any) => x.mainModuleName == name);
    if (GetFolderId.length > 0) {
       this.folderID = GetFolderId[0].folderID;
      if (GetFolderId[0].mainModuleName == ModuleName.Core) {        
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
      if (GetFolderId[0].mainModuleName == ModuleName.Contact) {        
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
      if (GetFolderId[0].mainModuleName == ModuleName.Company) {       
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
    }

    if(name==ModuleName.Core){
      this.getCoreList("");
    }
    if(name==ModuleName.Contact){
      this.getContactList("");
    }
    if(name==ModuleName.Company){
      this.getCompanyList("");
    }
    });
     var name = sessionStorage.getItem('gridViewModuleName');
     var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
     this.CCCList = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core || x.mainModuleName == ModuleName.Contact || x.mainModuleName == ModuleName.Company);
     
    var GetFolderId = [];
    GetFolderId = this.CCCList.filter((x:any) => x.mainModuleName == name);
    if (GetFolderId.length > 0) {
       this.folderID = GetFolderId[0].folderID;
      if (GetFolderId[0].mainModuleName == ModuleName.Core) {        
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
      if (GetFolderId[0].mainModuleName == ModuleName.Contact) {        
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
      if (GetFolderId[0].mainModuleName == ModuleName.Company) {       
        this.mainModuleName =GetFolderId[0].mainModuleName;
        this.orgModuleName =GetFolderId[0].orgModuleName;
      }
    }

    if(name==ModuleName.Core){
      this.getCoreList("");
    }
    if(name==ModuleName.Contact){
      this.getContactList("");
    }
    if(name==ModuleName.Company){
      this.getCompanyList("");
    }
    sessionStorage.setItem('HeaderModuleName', this.orgModuleName);
    this._dataSharingService.sendSelectedModuleName(this.orgModuleName);    
  }

  groupBy(event, column) {
    event.stopPropagation();
    this.checkGroupByColumn(column, true);
    //this.checkGroupByColumn(column.field, true);
    this.dataSource.data = this.addGroups(this._alldata, this.groupByColumns);
    this.dataSource.filter = performance.now().toString();
  }

  checkGroupByColumn(field, add) {
    let found = null;
    for (const column of this.groupByColumns) {
      if (column === field) {
        found = this.groupByColumns.indexOf(column, 0);
      }
    }
    if (found != null && found >= 0) {
      if (!add) {
        this.groupByColumns.splice(found, 1);
      }
    } else {
      if (add) {
        this.groupByColumns.push(field);
      }
    }
  }

  unGroupBy(event, column) {
    event.stopPropagation();
    this.checkGroupByColumn(column, false);
    //this.checkGroupByColumn(column.field, false);
    this.dataSource.data = this.addGroups(this._alldata, this.groupByColumns);
    this.dataSource.filter = performance.now().toString();
  }

  // below is for grid row grouping
  customFilterPredicate(data: any | Group, filter: string): boolean {
    return data instanceof Group ? data.visible : this.getDataRowVisible(data);
  }

  getDataRowVisible(data: any): boolean {
    const groupRows = this.dataSource.data.filter((row) => {
      if (!(row instanceof Group)) {
        return false;
      }
      let match = true;
      this.groupByColumns.forEach((column) => {
        if (!row[column] || !data[column] || row[column] !== data[column]) {
          match = false;
        }
      });
      return match;
    });

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }

  groupHeaderClick(row) {
    row.expanded = !row.expanded;
    this.dataSource.filter = performance.now().toString(); // bug here need to fix
  }

  addGroups(data: any[], groupByColumns: string[]): any[] {
    const rootGroup = new Group();
    rootGroup.expanded = true;
    return this.getSublevel(data, 0, groupByColumns, rootGroup);
  }

  getSublevel(
    data: any[],
    level: number,
    groupByColumns: string[],
    parent: Group
  ): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }
    const groups = this.uniqueBy(
      data.map((row) => {
        const result = new Group();
        result.level = level + 1;
        result.parent = parent;
        for (let i = 0; i <= level; i++) {
          result[groupByColumns[i]] = row[groupByColumns[i]];
        }
        return result;
      }),
      JSON.stringify
    );

    const currentColumn = groupByColumns[level];
    let subGroups = [];
    groups.forEach((group) => {
      const rowsInGroup = data.filter(
        (row) => group[currentColumn] === row[currentColumn]
      );
      group.totalCounts = rowsInGroup.length;
      const subGroup = this.getSublevel(
        rowsInGroup,
        level + 1,
        groupByColumns,
        group
      );
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    return subGroups;
  }

  uniqueBy(a, key) {
    const seen = {};
    return a.filter((item) => {
      const k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }

  isGroup(index, item): boolean {
    return item.level;
  }
 
  CCCListing() {
    var SelectedValue = this.CCCList.filter((x:any) => x.mainModuleName == this.mainModuleName);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      sessionStorage.setItem('coreshowListing', 'true'); 
      sessionStorage.removeItem("coreshowkanban");
      sessionStorage.removeItem("coreshowGrouping");   
      this.showView.emit('ListView');
      this.router.navigate(['/core/listing'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      sessionStorage.setItem('contactshowListing', 'true');  
      sessionStorage.removeItem("contactshowkanban");   
      sessionStorage.removeItem("contactshowGrouping");  
      this.showView.emit('ListView');    
      this.router.navigate(['/contact/listing'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      sessionStorage.setItem('companyshowListing', 'true');
      sessionStorage.removeItem("companyshowkanban");    
      sessionStorage.removeItem("companyshowGrouping");   
      this.showView.emit('ListView');       
      this.router.navigate(['/company/listing'], {});
    }
  }


  CCCKanban() {
    var SelectedValue = this.CCCList.filter((x:any) => x.mainModuleName == this.mainModuleName);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      sessionStorage.setItem('coreshowkanban', 'true');
      sessionStorage.removeItem("coreshowListing");     
      sessionStorage.removeItem('coreshowGrouping');
      this.router.navigate(['/core/kanbanview'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      sessionStorage.setItem('contactshowkanban', 'true');
      sessionStorage.removeItem("contactshowListing");     
      sessionStorage.removeItem('contactshowGrouping');
      this.router.navigate(['/contact/kanbanview'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      sessionStorage.setItem('companyshowkanban', 'true');
      sessionStorage.removeItem("companyshowListing");     
      sessionStorage.removeItem('companyshowGrouping');
      this.router.navigate(['/company/kanbanview'], {});
    }
  }

  CCCGridView(){
    //this.showView.emit('GridView');
  }
 

  //================  Core List ==========================================// 
  spinner:boolean=false;
  colCount = 1;

  getCoreList(filterValue) {    
    this.coreList = [];
    var ReqModel={    
      PageIndex : 0,
      PageSize : 2000,
      DatabaseID :  Number(this.databaseId),
      OrganizationID : Number(this.organizationId),
      UserID :  this.currentUser.UID,
      FolderId : this.folderID,
      searchKey:  filterValue,
      userContactID : Number(sessionStorage.getItem('userContactID')),
      RoleIDList :  sessionStorage.getItem('roleIDList').split(','),
      OfficeIDList : this.OfficeIDList,
      officeID :  this.myOfficeID,
      isArchived :false
    }    
    this.loaderService.show();
    this.spinner=true;
    this.settingsService.getCoreList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.coreFieldColumnToogle = [];
        this.responseHolder = response;      

        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.isAnyRecordAvailable = response.data.isAnyRecordAvailable;
          this.totalCount = response.data.totalcount;        
          this.coreList = this.isAnyRecordAvailable ? response.data.transactions : [];
             
        //  sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
         // this.Allids = response.data.ids;
          this.coreList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.coreUserListReceived = true;
          let temGridFinalArray = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          this.isAnyRecordAvailable && tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.coreFieldList = response.data.gridUserSettings;
        
          this.coreFieldList.forEach((ele) => {
            if( ele.isDisplay){
              this.colCount++; 
            }             
            if (ele.fieldName == "Status") {    
              ele.isDisplay=true;                      
            }
          });      

          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.availableOn != 2);
          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.rolePermission != 2);

          this.coreFieldListNew = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.fieldName != 'Image');

          this.coreListReceived = true;
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.rolePermission != 2);
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && this.coreFieldColumnToogle.filter((s) => s.availableOn != 2);
                                    
         
          this.CoresetDisplayedColumns();
          this.CoresetListToDisplay();
          this.loaderService.hide();
          this.spinner=false;
        } else {
          this.isAnyRecordAvailable = false;
          this.loaderService.hide();
          this.spinner=false;
          this.coreList = [];
          this.coreFieldList = [];
          this._returnList = [];        
        }
      } else {
        this.isAnyRecordAvailable = false;
        this.spinner=false;
        this.loaderService.hide();
      }
    });
  }

  CoresetDisplayedColumns() {
    this.displayedColumns = [];
    this.isAnyRecordAvailable && this.coreFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });
     this.columns =  this.displayedColumns;
     this.displayedColumns;
     this.groupByColumns = ['Status'];
  }

  CoresetListToDisplay() {
    if (this.coreUserListReceived && this.coreListReceived) {
      this.diplayList = [];
      var favorite: boolean = false;
      for (var user = 0; user < this.coreList.length; user++) {
        let tempUserFields: any[] = [];
        for (var coreField = 0; coreField < this.coreFieldList.length; coreField++) {
          let fieldFound = false;
          for (var userField = 0; userField < this.coreList[user].fields.length; userField++) {
            if (this.coreFieldList[coreField].fieldID == this.coreList[user].fields[userField].fieldID) {
              fieldFound = true;
              tempUserFields.push(this.coreList[user].fields[userField]);
              //break;
            }
            if (userField + 1 == this.coreList[user].fields.length && fieldFound == false) {
              var fieldValue = "";
              if(this.coreFieldList[coreField].fieldName=="Status"){
                var check=[];
                check=this.coreList.filter(x=>x.coreID == this.coreList[user].fields[0].coreID);
                if(check.length>0){
                  fieldValue=check[0].status;
                }else{
                  fieldValue="";
                }
              }
              var ReqModel = {
                fieldID: this.coreFieldList[coreField].fieldID,
                fieldName: this.coreFieldList[coreField].fieldName,
                fieldTypeID: this.coreFieldList[coreField].fieldTypeID,
                fieldTypeName: this.coreFieldList[coreField].fieldTypeName,
                fieldValue: fieldValue,
                transactionID: this.coreList[user].fields[0].coreID,
              };
              tempUserFields.push(ReqModel);
            }
          }
        }
        var _user = {
          fields: tempUserFields,
          transactionID: tempUserFields[0].coreID,
          isFavorite: this.coreList[user].isFavorite,
          paychexID: this.coreList[user].paychexID,
          pendingPatientId:this.coreList[user].pendingPatientId
        };
        this.diplayList.push(_user);
      }
    }

    this.coreListNew = [];
    this.coreListNew = this.diplayList;

    this._returnList = this.CoresetListForDrogandDrop1(this.coreListNew);

    if (this._returnList && this._returnList[0] && this._returnColumns) {
      for (var prop in this._returnList[0]) {
        this._returnColumns.push(prop);
      }
    }

    this.isAnyRecordAvailable && this.coreFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });


    this.groupByColumns = ['Status'];
    
    this._alldata = this._returnList;//data.data;
    this.dataSource.data = this.addGroups(
      this._alldata,
      this.groupByColumns
    );
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
    this.dataSource.filter = performance.now().toString();
   
  }

  CoresetListForDrogandDrop1(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    var pendingPatientId;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      pendingPatientId=element.pendingPatientId
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }
        
        if (ele.fieldName == "Name") {
          ele.fieldValue = this.getFullName(ele.fieldValue);
        }

        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['pendingPatientId'] = pendingPatientId;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }




  //============== Contact List ==============================//

  contactFieldList: any[] = [];
  contactFieldListNew: any[] = [];
  contactFieldColumnToogle: any[] = [];
  contactList: any[] = [];
  contactUserListReceived = false;
  contactListReceived = false;
  contactListNew: any[] = [];

  getContactList(filterValue) {    
    this.contactList = [];
    var ReqModel={    
      PageIndex : 0,
      PageSize : 2000,
      DatabaseID :  Number(this.databaseId),
      OrganizationID : Number(this.organizationId),
      UserID :  this.currentUser.UID,
      FolderId : this.folderID,
      searchKey:  filterValue,
      userContactID : Number(sessionStorage.getItem('userContactID')),
      RoleIDList :  sessionStorage.getItem('roleIDList').split(','),
      OfficeIDList : this.OfficeIDList,
      officeID :  this.myOfficeID,
      isArchived :false
    }    
    this.loaderService.show();
    this.spinner=true;
    this.settingsService.getContactList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.contactFieldColumnToogle = [];
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.isAnyRecordAvailable = response.data.isAnyRecordAvailable;
          this.totalCount = response.data.totalcount;
          this.contactList = this.isAnyRecordAvailable ? response.data.contacts : [];//transactions;
         // sessionStorage.setItem('contactList', JSON.stringify(response.data.contacts));
         // this.Allids = response.data.ids;
          this.contactList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.contactUserListReceived = true;
          let temGridFinalArray = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          this.isAnyRecordAvailable && tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.contactFieldList = response.data.gridUserSettings;
          this.contactFieldList.forEach((ele) => {
            if( ele.isDisplay){
              this.colCount++; 
            }
            if (ele.fieldName == "Status") {           
              ele.isDisplay=true;           
            }
          });
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.availableOn != 2);
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.rolePermission != 2);

          this.contactFieldListNew = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');

          this.contactListReceived = true;
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.rolePermission != 2);
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && this.contactFieldColumnToogle.filter((s) => s.availableOn != 2);
          this.ContactsetDisplayedColumns();
          this.ContactsetListToDisplay();
          this.loaderService.hide();
          this.spinner=false;
        } else {
          this.isAnyRecordAvailable = false;
          this.loaderService.hide();
          this.spinner=false;
          this.contactList = [];
          this.contactFieldList = [];
          this._returnList = [];         
        }
      } else {
        this.isAnyRecordAvailable = false;
        this.loaderService.hide();
        this.spinner=false;
      }
    });
  }

   ContactsetDisplayedColumns() {
    this.displayedColumns = [];
    this.isAnyRecordAvailable && this.contactFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });
    this.columns =  this.displayedColumns;
    this.displayedColumns;
    this.groupByColumns = ['Status'];
  }


  ContactsetListToDisplay() {
    if (this.contactUserListReceived && this.contactListReceived) {
      this.diplayList = [];
      var favorite: boolean = false;
      for (var user = 0; user < this.contactList.length; user++) {
        let tempUserFields: any[] = [];
        for (var coreField = 0;
          coreField < this.contactFieldList.length;
          coreField++
        ) {
          let fieldFound = false;
          for (var userField = 0; userField < this.contactList[user].fields.length; userField++) {
            if (
              this.contactFieldList[coreField].fieldID ==
              this.contactList[user].fields[userField].fieldID
            ) {
              fieldFound = true;
              tempUserFields.push(this.contactList[user].fields[userField]);
              // break;
            }
            if (userField + 1 == this.contactList[user].fields.length && fieldFound == false) {
              var fieldValue = "";
              if(this.contactFieldList[coreField].fieldName=="Status"){
                var check=[];
                check=this.contactList.filter(x=>x.contactID == this.contactList[user].fields[0].coreID);
                if(check.length>0){
                  fieldValue=check[0].status;
                }else{
                  fieldValue="";
                }
              }
              var ReqModel = {
                fieldID: this.contactFieldList[coreField].fieldID,
                fieldName: this.contactFieldList[coreField].fieldName,
                fieldTypeID: this.contactFieldList[coreField].fieldTypeID,
                fieldTypeName: this.contactFieldList[coreField].fieldTypeName,
                fieldValue: fieldValue,
                transactionID: this.contactList[user].fields[0].coreID,
              };
              tempUserFields.push(ReqModel);
            }
          }
        }
        var _user = {
          fields: tempUserFields,
          transactionID: tempUserFields[0].contactID,
          isFavorite: this.contactList[user].isFavorite,
          paychexID: this.contactList[user].paychexID
        };
        this.diplayList.push(_user);
      }
    }

    this.contactListNew = [];
    this.contactListNew = this.diplayList;

    this._returnList = this.ContactsetListForDrogandDrop(this.contactListNew);

    if (this._returnList && this._returnList[0] && this._returnColumns) {
      for (var prop in this._returnList[0]) {
        this._returnColumns.push(prop);
      }
    }

    this.isAnyRecordAvailable && this.contactFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });

    this.groupByColumns = ['Status'];
    
    this._alldata = this._returnList;//data.data;
    this.dataSource.data = this.addGroups(
      this._alldata,
      this.groupByColumns
    );
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
    this.dataSource.filter = performance.now().toString();   
  }

  ContactsetListForDrogandDrop(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }
        if (ele.fieldName == "Name") {
          ele.fieldValue = this.getFullName(ele.fieldValue);
        }
        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }


   //============== Company List ==============================//

   companyFieldList: any[] = [];
   companyFieldListNew: any[] = [];
   companyFieldColumnToogle: any[] = [];
   companyList: any[] = [];
   companyUserListReceived = false;
   companyListReceived = false;
   checkRecentFilter: any[] = [];
   checkDefaultFilter: any[] = [];

  getCompanyList(filterValue) {
    this.companyList = [];
    var ReqModel={    
      PageIndex : 0,
      PageSize : 2000,
      DatabaseID :  Number(this.databaseId),
      OrganizationID : Number(this.organizationId),
      UserID :  this.currentUser.UID,
      FolderId : this.folderID,
      searchKey:  filterValue,
      userContactID : Number(sessionStorage.getItem('userContactID')),
      RoleIDList :  sessionStorage.getItem('roleIDList').split(','),
      OfficeIDList : this.OfficeIDList,
      officeID :  this.myOfficeID,
      isArchived :false
    }    
    this.loaderService.show();
    this.spinner=true;
    this.settingsService.getCompanyList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.companyFieldColumnToogle = [];
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.isAnyRecordAvailable = response.data.isAnyRecordAvailable;
          this.totalCount = response.data.totalcount;
          this.companyList = this.isAnyRecordAvailable ? response.data.companies : [];
          //sessionStorage.setItem('companyList', JSON.stringify(response.data.companies));
          //this.Allids = response.data.ids;

          this.companyList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.companyUserListReceived = true;
          let temGridFinalArray = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          this.isAnyRecordAvailable && tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.companyFieldList = response.data.gridUserSettings;

          this.companyFieldList.forEach((ele) => {
            if( ele.isDisplay){
              this.colCount++; 
            }
            if (ele.fieldName == "Status") {
            

              ele.isDisplay=true;           
            }
          });


          this.companyFieldList = this.isAnyRecordAvailable && this.companyFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
          if (this.checkRecentFilter.length > 0 || this.checkDefaultFilter.length > 0) {
            this.companyFieldList = this.companyFieldList.filter((s) => s.availableOn != 2);
            this.companyFieldList = this.companyFieldList.filter((s) => s.rolePermission != 2);
          }

          this.companyFieldListNew = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');

          


          this.companyListReceived = true;
          this.companyFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.companyFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.rolePermission != 2);
          this.companyFieldColumnToogle = this.isAnyRecordAvailable && this.companyFieldColumnToogle.filter((s) => s.availableOn != 2);
          this.CompanysetDisplayedColumns();
          this.CompanysetListToDisplay();
          this.loaderService.hide();
          this.spinner=false;
        } else {
          this.isAnyRecordAvailable = false;
          this.loaderService.hide();
          this.spinner=false;
          this.companyList = [];
          this.companyFieldList = [];
          this._returnList = [];
          // this.dataSource = new MatTableDataSource();
          // this.dataSource.data = [];
          // this.dataSource.paginator = null;
          // this.dataSource.sort = this.sort;
          // this.paginatorTotalLength = 0;
        }
      } else {
        this.isAnyRecordAvailable = false;
        this.loaderService.hide();
        this.spinner=false;
      }
    });
  }


  CompanysetDisplayedColumns() {
    this.displayedColumns = [];
    this.isAnyRecordAvailable && this.companyFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });
    this.columns =  this.displayedColumns;
    this.displayedColumns;
    this.groupByColumns = ['Status'];
  }

  CompanysetListToDisplay() {
    if (this.companyUserListReceived && this.companyListReceived) {
      this.diplayList = [];
      var favorite: boolean = false;
      for (var user = 0; user < this.companyList.length; user++) {
        let tempUserFields: any[] = [];
        for (
          var coreField = 0;
          coreField < this.companyFieldList.length;
          coreField++
        ) {
          let fieldFound = false;
          for (
            var userField = 0;
            userField < this.companyList[user].fields.length;
            userField++
          ) {
            if (
              this.companyFieldList[coreField].fieldID ==
              this.companyList[user].fields[userField].fieldID
            ) {
              fieldFound = true;
              tempUserFields.push(this.companyList[user].fields[userField]);
              //   break;
            }
            if (userField + 1 == this.companyList[user].fields.length && fieldFound == false) {
              var fieldValue = "";
              if(this.companyFieldList[coreField].fieldName=="Status"){
                var check=[];
                check=this.companyList.filter(x=>x.companyID == this.companyList[user].fields[0].coreID);
                if(check.length>0){
                  fieldValue=check[0].status;
                }else{
                  fieldValue="";
                }
              }
              var ReqModel = {
                fieldID: this.companyFieldList[coreField].fieldID,
                fieldName: this.companyFieldList[coreField].fieldName,
                fieldTypeID: this.companyFieldList[coreField].fieldTypeID,
                fieldTypeName: this.companyFieldList[coreField].fieldTypeName,
                fieldValue: fieldValue,
                transactionID: this.companyList[user].fields[0].companyID,
              };
              tempUserFields.push(ReqModel);
            }
          }
        }
        var _user = {
          fields: tempUserFields,
          transactionID: tempUserFields[0].companyID,
          isFavorite: this.companyList[user].isFavorite,
          paychexID: this.companyList[user].paychexID
        };
        this.diplayList.push(_user);
      }
    }

    this.contactListNew = [];
    this.contactListNew = this.diplayList;

    this._returnList = this.CompanysetListForDrogandDrop(this.contactListNew);

    if (this._returnList && this._returnList[0] && this._returnColumns) {
      for (var prop in this._returnList[0]) {
        this._returnColumns.push(prop);
      }
    }

    this.isAnyRecordAvailable && this.companyFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });

    this._alldata = this._returnList;//data.data;
    this.dataSource.data = this.addGroups(
      this._alldata,
      this.groupByColumns
    );
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
    this.dataSource.filter = performance.now().toString();
  }


  CompanysetListForDrogandDrop(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }
        if (ele.fieldName == "Name") {
          ele.fieldValue = this.getFullName(ele.fieldValue);
        }

        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }


  getFullName(fullName) {
    var tarea = fullName;
    if (/(http(s?)):\/\//i.test(tarea)) {
      fullName = fullName;
      fullName = fullName.split(',');
      return fullName[0];
    } else {
      fullName = fullName;
      return fullName;
    }
  }


  SubmitColumnsButton: boolean = false;
  folderListForID: any = [];
  folderId: number = 0;

  customizeColumn(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.SubmitColumnsButton=true;
    if(this.mainModuleName==ModuleName.Core){
     this.FieldColumnToogle=this.coreFieldColumnToogle;
    }
    if(this.mainModuleName==ModuleName.Contact){
      this.FieldColumnToogle=this.contactFieldColumnToogle;
    }
    if(this.mainModuleName==ModuleName.Company){
      this.FieldColumnToogle=this.companyFieldColumnToogle;
    }
    this.setListForToggle();
  }
  
  setListForToggle() {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var modulename = menuModulesList.filter((x:any) => x.mainModuleName == this.mainModuleName);
    if (modulename[0].mainModuleName == ModuleName.Core) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
        
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Contact) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Company) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
      });
    }
  }

  changedToggle(item, event) {
    this.SubmitColumnsButton = false;
    this.folderListForID = JSON.parse(sessionStorage.getItem("menuModules"));
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));   
    var modulename = menuModulesList.filter((x:any) => x.mainModuleName == this.mainModuleName);
    if (modulename[0].mainModuleName == ModuleName.Core) {
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Core);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//17;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Contact) {     
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Contact);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//20;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Company) {     
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Company);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//19;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
  }


  onSubmitColumns() {  
    this.ToogleColumnFields;
    let NewToogleColumnFields = this.ToogleColumnFields.filter((v, i) => this.ToogleColumnFields.findIndex(item => item.FieldID == v.FieldID) === i);
    this.submitCoreColumn(NewToogleColumnFields);   
  }

  submitCoreColumn(result:any){
    this.SubmitColumnsButton=true;
    var ReqModel={
      userID : this.currentUser.UID,
      databaseID : Number(this.databaseId),
      organizationID : Number(this.organizationId),
      officeID : this.myOfficeID,
      officeIDList : this.OfficeIDList,
      customizationGridUserSetting : result
    } 
    this.settingsService.updateCoreFieldColumnList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialog.closeAll();
          this.getCoreList("");
        }
      }
    });
  }

  close(){
    this.dialog.closeAll();
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    if(this.mainModuleName==ModuleName.Core){
      this.getCoreList(this.filterText);
    }
    if(this.mainModuleName==ModuleName.Contact){
      this.getContactList(this.filterText);
    }
    if(this.mainModuleName==ModuleName.Company){
      this.getCompanyList(this.filterText);
    }
  }

  Search(filterValue) {
    if(this.mainModuleName==ModuleName.Core){
      this.getCoreList(filterValue);
    }
    if(this.mainModuleName==ModuleName.Contact){
      this.getContactList(filterValue);
    }
    if(this.mainModuleName==ModuleName.Company){
      this.getCompanyList(filterValue);
    }
  }

  TransactionId:number=0;
  showDetail: boolean = false;

  showListingDetail(actionObjnew?: any, actionObj?: any) {
    if (actionObj != 'Name') {
      var SelectedValue = this.CCCList.filter((x:any) => x.mainModuleName == this.mainModuleName);
      if (SelectedValue[0].mainModuleName == ModuleName.Core){
        this.TransactionId = actionObjnew.CoreID;  
        this.showDetail = !this.showDetail;       
      }      
      if (SelectedValue[0].mainModuleName == ModuleName.Contact){
         this.TransactionId = actionObjnew.CoreID;  
         this.showDetail = !this.showDetail;    
      }
      if (SelectedValue[0].mainModuleName == ModuleName.Company){
         this.TransactionId = actionObjnew.CoreID;  
         this.showDetail = !this.showDetail;    
      }
    }
   
  }

  OpenProfile(actionObj: any) {
    //var SelectedValue = this.CCCList.filter((x:any) => x.mainModuleName == this.mainModuleName);
   
    var list=[];
    var fildsList=[];
    var id;
    
    if (this.mainModuleName == ModuleName.Core){
       id = actionObj.CoreID;
      list =  JSON.parse(sessionStorage.getItem("coreList"));
    }
    
     if (this.mainModuleName == ModuleName.Contact){
      id = actionObj.CoreID;  
      list =  JSON.parse(sessionStorage.getItem("contactList"));
     }
     if (this.mainModuleName == ModuleName.Company){
      id = actionObj.CoreID;  
      list =  JSON.parse(sessionStorage.getItem("companyList"));
     }
     if(list==null){
      list=[];
     }
     if(list.length>0){
      if (this.mainModuleName == ModuleName.Core){
        list = list.filter(x=>x.coreID == id);
      }
      if (this.mainModuleName == ModuleName.Contact){
        list = list.filter(x=>x.contactID == id);
      }
      if (this.mainModuleName == ModuleName.Company){
        list = list.filter(x=>x.companyID == id);
      }
      if(list.length>0){
        fildsList =list[0].fields;
        if(fildsList.length>0){
          fildsList=fildsList.filter(x=>x.fieldName=="Type");
          if(fildsList.length>0){
            actionObj.TypeID=fildsList[0].subFolderID;
          }
        }
      }     
     }
    if (actionObj.TypeID == null || actionObj.TypeID == undefined) {
      actionObj.TypeID = 0;
    }     
    sessionStorage.setItem('transactionID', id);
    sessionStorage.setItem('TypeID', actionObj.TypeID);
    sessionStorage.setItem('moduleName', this.mainModuleName);
    if (this.mainModuleName == ModuleName.Core) {
      let tasktab = "/core/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      // let tasktab = "/core/documents?&tID=" + id + "&type=" + actionObj.TypeID;
      window.open(tasktab, "_blank");
      // this.router.navigate(['/core/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      //  this._dataSharingService.sendSelectedCoreUser(tagId);
    }

    if (this.mainModuleName == ModuleName.Contact) {
      let tasktab = "/contact/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      window.open(tasktab, "_blank");
      // this.router.navigate(['/contact/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      // this._dataSharingService.sendSelectedContactUser(tagId);
    }

    if (this.mainModuleName == ModuleName.Company) {
      let tasktab = "/company/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      window.open(tasktab, "_blank");
      // this.router.navigate(['/company/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      //this._dataSharingService.sendSelectedCompanyUser(tagId);
    }
  }

  ViewProfile(actionObjnew?: any, actionObj?: any) {
    if(actionObj == 'Name'){
      var list=[];
      var fildsList=[];
      var id;                      
      
       if (this.mainModuleName == ModuleName.Core){
        id = actionObjnew.CoreID;
        list =  JSON.parse(sessionStorage.getItem("coreList"));       
       }    
       if (this.mainModuleName == ModuleName.Contact){
        id = actionObjnew.CoreID;  
        list =  JSON.parse(sessionStorage.getItem("contactList"));
       }
       if (this.mainModuleName == ModuleName.Company){
        id = actionObjnew.CoreID;  
        list =  JSON.parse(sessionStorage.getItem("companyList"));
       }
       if(list==null){
        list=[];
       }
       if(list.length>0){
        if (this.mainModuleName == ModuleName.Core){
          list = list.filter(x=>x.coreID == id);
        }
        if (this.mainModuleName == ModuleName.Contact){
          list = list.filter(x=>x.contactID == id);
        }
        if (this.mainModuleName == ModuleName.Company){
          list = list.filter(x=>x.companyID == id);
        }
        if(list.length>0){
          fildsList =list[0].fields;
          if(fildsList.length>0){
            fildsList=fildsList.filter(x=>x.fieldName=="Type");
            if(fildsList.length>0){
              actionObjnew.TypeID=fildsList[0].subFolderID;
            }
          }
        }     
       }
      if (actionObjnew.TypeID == null || actionObjnew.TypeID == undefined) {
        actionObjnew.TypeID = 0;
      }    
      
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', actionObjnew.TypeID);
      sessionStorage.setItem('moduleName', this.mainModuleName);
      if (this.mainModuleName == ModuleName.Core) {
        this.router.navigate(['/core/documents'], {});
        this._dataSharingService.sendNextPreviousDocumentFromCore(false);
        this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
        this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      }
  
      if (this.mainModuleName  == ModuleName.Contact) {
        this.router.navigate(['/contact/documents'], {});
        this._dataSharingService.sendNextPreviousDocumentFromContact(false);
        this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
        this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      }
  
      if (this.mainModuleName  == ModuleName.Company) {
        this.router.navigate(['/company/documents'], {});
        this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
        this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
        this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
       }
    }
  }
  
  getCloseDetails(message){
    this.showDetail = false;
  }

  Saved3C(result){
    if(this.mainModuleName == ModuleName.Core){
      this.getCoreList("");
    }
    if(this.mainModuleName == ModuleName.Contact){
      this.getContactList("");
    }
    if(this.mainModuleName == ModuleName.Company){
      this.getCompanyList("");
    }
  }

  isPhone(element: any, fieldName: string): boolean {
    return this.getKeyByValue(element, element[fieldName]) == 'Phone';
  }

  isEmail(element: any, fieldName: string): boolean {
    return this.getKeyByValue(element, element[fieldName]) == 'Email';
  }

  // The cell for this column is clamped to two lines (see
  // .cdk-column-Primary-Diagnosis), so the full text goes in a tooltip.
  // Matched loosely because the CDK column class turns any separator into '-'.
  isPrimaryDiagnosis(column: any): boolean {
    return String(column || '').replace(/[^a-z0-9]+/gi, '-').toLowerCase() === 'primary-diagnosis';
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  
}


